import React, { useContext, useState } from 'react';
import Dashboard_Model from './dashboard/Dashboard_Model';
import { VscDiffAdded } from "react-icons/vsc";
import { IoCaretBack } from "react-icons/io5";
import { CgCloseO } from "react-icons/cg";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/Auth';
import ModulesTable from './dashboard/ModulesTable';

const ModulesInfo = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const { allModuleInfo } = useContext(AuthContext);
  const [isAddModules, setIsAddModules] = useState(false);
  return (
    <div className="bg-green-50 pb-12 md:pb-0 min-h-screen ">
      <div className='flex px-4 sticky bg-green-50 top-0 coda-regular items-center justify-between py-4 border-b border-green-300 w-full'>
        <div className='md:flex hidden items-center gap-2'>
          <IoCaretBack onClick={() => navigate(-1)} className="flex items-center justify-center w-fit h-fit px-4 py-2 text-white bg-red-600 rounded shadow hover:bg-red-700 hover:shadow-lg transition-all duration-300 cursor-pointer" />
        </div>
        <h1 className='font-extrabold hidden md:flex text-2xl opacity-75'>
          All Modules Information
        </h1>
        <div>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-[40vw] p-1 px-2 border border-gray-300 rounded focus:outline-none "
          />
        </div>
        {/* <h1 className='font-extrabold md:hidden text-2xl opacity-75'>Modules</h1> */}
        <button
          onClick={() => setIsAddModules(!isAddModules)}
          className={`flex text-sm font-bold items-center justify-center w-fit h-fit px-5 py-2 text-white ${isAddModules ? "bg-red-600 hover:bg-red-700" : "bg-green-600 hover:bg-green-700"} rounded md:shadow hover:shadow-lg transition-transform transform hover:scale-105 duration-300 cursor-pointer`}
        >
          {isAddModules ? (
            <div className="flex items-center font-mono space-x-2">
              <CgCloseO size={18} />
              <span>Close</span>
            </div>
          ) : (
            <div className="flex font-mono items-center space-x-2">
              <VscDiffAdded size={18} />
              <span>Add Module</span>
            </div>
          )}
        </button>

      </div>
      {!isAddModules && !allModuleInfo && <p className="text-lg coda-regular text-center text-gray-700">No Information Available</p>}
      {!isAddModules && allModuleInfo && <ModulesTable searchTerm={searchTerm} setSearchTerm={setSearchTerm} />}
      {isAddModules && <Dashboard_Model />}
    </div>
  );
};

export default ModulesInfo;
